module.exports = __webpack_public_path__ + "img/10_FCT NOVA_DCV.887bd7ab.jpg";